import styled from "styled-components";
import { breakpoints } from "styles";

export const CocoImageWrapper = styled.div<{ backgroundImage: unknown }>`
  display: flex;
  flex-direction: column-reverse;
  height: 165px;
  width: 210px;
  background: ${({ backgroundImage }) => `url(${backgroundImage as string})`};
  background-repeat: no-repeat;
  background-size: cover;

  @media ${breakpoints.laptop} {
    height: 210px;
    width: 265px;
  }
`;

export const CocoImageText = styled.p<{ color: string }>`
  color: ${({ color }) => color};
  text-align: center;
  bottom: 16px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  margin: 0 0 16px 0;
  font-size: ${({ theme }) => theme.fontSizes["sm"]};

  @media ${breakpoints.laptop} {
    margin-bottom: 16px;
    font-size: ${({ theme }) => theme.fontSizes["lg"]};
  }
`;
